import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterBar } from '../../../../../components/ui/FilterBar';
import { SearchInput } from '../../../../../components/ui/SearchInput';
import { FilterableSelect } from '../../../../../components/ui/FilterableSelect';
import { PLATFORMS } from '../../../../../features/ecommerces/ecommercesPlatforms';
import { setEcommerceFilters } from '../../../../../features/ecommerces/ecommercesSlice';
import { selectEcommerceFilters } from '../../../../../features/ecommerces/ecommercesSelectors';

const PLATFORM_OPTIONS = [
  { value: '', label: 'Todas las plataformas' },
  ...PLATFORMS.map((platform) => ({ value: platform.slug, label: platform.name })),
];

/** Search, platform and warehouse. The listing is filtered in the browser. */
const EcommerceFilters = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectEcommerceFilters);
  const warehouses = useSelector((state) => state.ecommerces.warehouses);

  const warehouseOptions = useMemo(
    () => [
      { value: '', label: 'Todas las bodegas' },
      ...warehouses.map((warehouse) => ({ value: String(warehouse.id), label: warehouse.name })),
    ],
    [warehouses]
  );

  return (
    <FilterBar variant="bare" testId="ecommerce-filters">
      <SearchInput
        variant="bare"
        testId="ecommerce-search"
        placeholder="Buscar por plataforma, bodega o tienda..."
        value={filters.search}
        onChange={(search) => dispatch(setEcommerceFilters({ search }))}
      />
      <FilterableSelect
        testId="ecommerce-platform-filter"
        value={filters.platform}
        onChange={(platform) => dispatch(setEcommerceFilters({ platform }))}
        options={PLATFORM_OPTIONS}
        placeholder="Plataforma"
        searchPlaceholder="Buscar plataforma..."
      />
      <FilterableSelect
        testId="ecommerce-warehouse-filter"
        value={filters.warehouse}
        onChange={(warehouse) => dispatch(setEcommerceFilters({ warehouse }))}
        options={warehouseOptions}
        placeholder="Bodega"
        searchPlaceholder="Buscar bodega..."
      />
    </FilterBar>
  );
};

export default memo(EcommerceFilters);
